module.exports = __webpack_public_path__ + "static/media/upload-multiple.da944559.svg";